import { useState } from "react";
import { Link } from "react-router-dom";
import useRequireAdmin from "../../hooks/useRequireAdmin";
import AdminNav from "../../components/AdminNav";
import ProductForm from "../../components/ProductForm";

export default function AddNewProducts() {
  const checking = useRequireAdmin();
  const [notice, setNotice] = useState("");

  if (checking) {
    return (
      <div className="adm">
        <p className="adm-muted">Checking admin permissions...</p>
      </div>
    );
  }

  return (
    <div className="adm">
      <div className="adm-header">
        <h2 className="adm-title">Add new product</h2>
        <div className="adm-header-actions">
          <Link to="/admin/products" className="ui-btn ui-btn--ghost">
            All products
          </Link>
        </div>
      </div>

      <AdminNav />

      {notice && (
        <p className="ui-alert ui-alert--ok" role="status">
          {notice} <Link to="/admin/products">View all products</Link>
        </p>
      )}

      <div className="adm-narrow">
        {/* The form clears itself after each product, ready for the next one */}
        <ProductForm
          onSaved={({ name }) => setNotice(`"${name}" was added. You can add another below.`)}
        />
      </div>
    </div>
  );
}